import moment from "moment";
import thTH from "antd/es/locale/th_TH";
import enUS from "antd/es/locale/en_US";

// โหลดข้อมูลภาษาไทยของ moment แต่ไม่เปลี่ยน global locale
// moment.defineLocale("th") ใน moment/locale/th ตั้ง global locale เป็น "th" ไปด้วย
// แต่หน้าต่าง ๆ format / parse วันที่ด้วย global locale จึงคืนค่าเดิมทันที
const globalLocale = moment.locale();
require("moment/locale/th");
moment.locale(globalLocale);

// DatePicker ของ antd (rc-picker) ใช้ moment อีกชุดใน node_modules ของตัวเอง ซึ่งไม่มีภาษาไทย
// rc-picker อ่านชื่อวันและชื่อเดือนจาก locale ของ picker ก่อน จึงใส่ชื่อภาษาไทยให้ตรงนั้น
const thaiDates = moment.localeData("th");
const withThaiDateNames = (pickerLocale) => ({
  ...pickerLocale,
  lang: {
    ...pickerLocale.lang,
    shortWeekDays: thaiDates.weekdaysMin(),
    shortMonths: thaiDates.monthsShort(),
  },
});

// locale ของ ConfigProvider ตามภาษาที่เลือก: ข้อความในตัว antd (Empty, Pagination, DatePicker,
// Popconfirm / Modal ปุ่มค่าเริ่มต้น, ตัวกรองและการเรียงของ Table) เปลี่ยนตามภาษา
export const antdLocales = {
  th: {
    ...thTH,
    DatePicker: withThaiDateNames(thTH.DatePicker),
    Calendar: withThaiDateNames(thTH.Calendar),
  },
  en: enUS,
};

export default antdLocales;
